import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class ConsultaVendaAcessoriosService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/consulta-venda-acessorios`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    partnumber?: any): Observable<any> {
    
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    
    if (!currentUser || !currentUser.token) {
      throw new Error('Usuário não autenticado');
    }
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${currentUser.token}`
    });
    
    const params = new HttpParams()
      .set('data_inicial', data_inicial ? data_inicial.toString() : '')
      .set('data_final', data_final ? data_final.toString() : '')
      .set('partnumber', partnumber ? partnumber.toString() : '');
    
    return this.httpClient.get<any>(`${this.baseUrlService}/consulta-venda-acessorios`, {
      headers: headers,
      params: params
    });
  }
}
